<template>
  <!-- 远程带教授权 -->
  <div class="my-distance">
    <img src="@/assets/images/person/vector.png" class="vector" alt="">
    <div class="header">
      <div class="header-text">
        以下为已授权远程带教医院
      </div>
    </div>
    <div class="distance-menu">
      <van-list v-model="loading" @load="onLoad" v-if="list.length > 0 && !isNone" :finished="finished" finished-text="我是有底线的"
        loading-text="正在加载..." class="cons-list">
        <div class="flex-con" v-for="(item, index) in list" :key="index">
          <div class="title">{{ item && item.hospital }}</div>
          <div class="flex-bottom">
            <div class="left-con">
              <div class="txt1">{{ userInfo && userInfo.realName }}</div>
              <div class="txt2">
                <span class="span2">查看<span class="deal" @click="handleCarto">《Carto远程服务协议》</span></span>
              </div>
            </div>
            <div class="right-con">
              <div class="distance-btn" @click="handleRelieve(item)">{{item.authStatus?'解除绑定':'绑定医院'}}</div>
            </div>
          </div>
        </div>
      </van-list>
      <div class="search-none" v-else-if="list.length <= 0 && isNone">
        <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
        <div class="none-txt">暂无内容</div>
      </div>
    </div>
    <returnBack></returnBack>
    <div class="dialog-unlock">
      <van-dialog v-model="dailogShow" title="解除绑定" :show-confirm-button="false">
        <div class="di_content">删除后将解除授权关系</div>
        <div class="di_btn_group">
          <div class="di_btn cancel"  @click.stop="handleGoBack">取消</div>
          <div class="di_btn ok" @click.stop="handleClickOk">确认</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import returnBack from '@/views/person/components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { relieveByUserId, queryListByUserId } from '@/api/person'
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
const UserProfile = {
  name: 'DistanceEducation',
  components: {
    returnBack
  },
  data() {
    return {
      dailogShow: false,
      curItem: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
      list: [],
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      this.load = true
      let params = {
        userId: this.userInfo.id,
        authStatus: 1,
      }
      queryListByUserId(params).then(res => {
        this.loading = false
        this.list = res.data.list
        this.finished = true
        this.isNone = false
      })
    },
    // Carto远程服务协议
    handleCarto() {
      this.$router.push({
        path: '/cartoDictonary',
        query: {
          hospitalName: this.list[0].hospital,
          createTime: this.list[0].createTime
        }
      })
    },
    handleGoBack() {
      this.dailogShow = false
    },
    // 解除绑定
    handleClickOk() {
      relieveByUserId({
        userId: this.userInfo.id,
        authStatus: 0
      }).then(res => {
        this.handleGoBack()
        this.$router.replace('/person')
      })
    },
    handleRelieve() {
      this.dailogShow = true
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-distance {
  background: #F9F8F7;
  min-height: 100vh;
  width: 100vw;
  position: relative;
  .vector {
    position: absolute;
    right: 30px;
    top: 40px;
    width: 84px;
  }
  .header {
    position: relative;
    padding:58px 16px 14px;
    display: flex;
    align-items: center;
    .header-text {
      font-size: 16px;
      font-weight: bold;
      color: #EB1700;
    }
  }

  .distance-menu {
    position: relative;
    width: calc(100% - 24px);
    padding-bottom: 15px;
    margin: 0 12px;

    .cons-list {
      border-radius: 12px;
      position: relative;
      box-sizing: border-box;
    }

    .flex-con {
      box-sizing: border-box;
      align-items: center;
      margin-bottom: 10px;
      border-radius: 14px;
      border: 0.5px solid rgba(213, 207, 201, 0.55);
      background: linear-gradient(90.00deg, rgb(247, 244, 243),rgb(255, 255, 255) 100%);

      .title {
        font-weight: 500;
        font-size: 16px;
        color: #282828;
        line-height: 20px;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 10px 12px;
      }

      .flex-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 8px 12px 0;
        border-radius: 12px 12px 0 0;
        .right-con {
          display: flex;
          flex-flow: row-reverse;
          align-items: center;
          width: 110px;
          height: 60px;
          position: relative;
          border-radius: 5px;
          overflow: hidden;

          .distance-btn {
            width: 84px;
            height: 24px;
            font-weight: 400;
            font-size: 14px;
            background: #EB1700;
            line-height: 24px;
            text-align: center;
            color: #fff;
            border-radius: 13px;
          }

        }

        .left-con {
          .txt1 {
            font-size: 14px;
            color: #000;
            font-weight: 500;
            line-height: 20px;
            margin-bottom: 10px;
            width: 180px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .txt2 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #A39992;
            font-size: 12px;

            .span1 {
              width: 130px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .deal {
              color: #EB1700;
              font-weight: 400;
              font-size: 12px;
            }
          }
        }
      }
    }

    .search-none {
      padding-bottom: 40px;
      box-sizing: border-box;

      .none-img {
        width: 185px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 150px;
      }

      .none-txt {
        font-size: 12px;
        color: #949BA5;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
  .van-dialog {
  width: 320px;
  height: 195px;
  background-size: 100% 100%;
  &.di_dialog {
    height: auto;
  }

  /deep/.van-dialog__header {
    font-family: Source Han Sans CN, Source Han Sans CN;
    color: #000000;
    font-weight: 600;
    font-size: 17px;
    padding-top: 15px;
    line-height: 24px;
  }
}

.di_content {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  padding: 28px 26px;
  box-sizing: border-box;
  line-height: 21px;
}

.di_btn_group {
  display: flex;
  padding: 0 17px;
  box-sizing: border-box;
  justify-content: space-between;

  .di_btn {
    width: 130px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    border-radius: 20px 20px 20px 20px;
  }

  .ok {
    background: #EB1700;
    box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
    color: #fff;
  }

  .cancel {
    background: rgba(0, 0, 0, 0.08);
    color: #7a8494;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/views/person/distanceEducation.vue